import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import SignupPromoDialog from "./SignupPromoDialog";

const SESSION_KEY = "gn_signup_promo_shown";
const DELAY_MS = 25_000;

// Routes where the popup should NOT appear (auth flows, checkout, admin).
const BLOCKED_PREFIXES = [
  "/auth",
  "/reset-password",
  "/checkout",
  "/billing",
  "/plus/checkout",
  "/admin",
  "/unsubscribe",
];

function isBlocked(pathname: string) {
  return BLOCKED_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));
}

export default function SignupPromoController() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (user) return;
    if (isBlocked(location.pathname)) return;
    if (typeof window === "undefined") return;
    try {
      if (sessionStorage.getItem(SESSION_KEY) === "true") return;
    } catch {
      return;
    }

    const timer = window.setTimeout(() => {
      // Re-check guards at fire-time in case route or auth changed.
      if (isBlocked(window.location.pathname)) return;
      try {
        sessionStorage.setItem(SESSION_KEY, "true");
      } catch {}
      setOpen(true);
    }, DELAY_MS);

    return () => window.clearTimeout(timer);
  }, [user, loading, location.pathname]);

  if (!open) return null;
  return <SignupPromoDialog open={open} onOpenChange={setOpen} />;
}
